import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { deleteCookie, getCookie, setCookie } from "../../utils/httpRequest";
import { tokenKey } from "../../global";
import { useDispatch } from "react-redux";
import { LogoutUserMutation } from "./LogoutUserMutation";

type AuthContextValue = {
  isAuthenticated: boolean;
  token: string | null;
  login: (token: string, refreshToken: string) => void;
  logout: (viewerId:string) => void;
};

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch()
  const [token, setToken] = useState<string | null>(() => localStorage.getItem("token"));
  
  const login = (newToken: string, newRefreshToken: string,) => {
    setToken(newToken);
    setCookie(tokenKey, newToken)
    setCookie('refreshToken', newRefreshToken)

  };
  const handleLogout = async (viewerId:string) => {
    const userId = window.btoa(viewerId)
    const { refreshToken } = await getCookie('refreshToken')
    dispatch(
      LogoutUserMutation(
        {
          userId,
          refreshToken: refreshToken!,
        },
        {
          onSuccess: (response?: any) => {
            logout()
          },

        }
      )
    )
  }
  const logout = () => {
    setToken(null);
    deleteCookie(tokenKey)
    deleteCookie('refreshToken')
  };

  // keep tabs/windows in sync
  useEffect(() => {
    const token = getCookie(tokenKey)
    setToken(token)
  }, []);

  const value = useMemo(
    () => ({ isAuthenticated: !!token, token, login, logout:handleLogout }),
    [token]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};